import { IDKind } from '@startuptools/common/common';
import { type GqlIdentity } from '../../../graphql/base-types.graphql';
import { JuridicalKind } from '../types';

export type I = Pick<
  GqlIdentity,
  'juridicalKind' | 'countryCode' | 'email' | 'name' | 'address' | 'id' | 'identityNumber' | 'identityNumberKind'
>;

export const fictitiousIdentities: (I & { label: string })[] = [
  {
    id: 'e76cd009-c9a3-4ed9-b3ad-8116d33502d0',
    name: 'Per Persson',
    juridicalKind: JuridicalKind.Person,
    countryCode: 'SE',
    email: 'identity1@example.com',
    address: 'Address 1',
    identityNumber: '19900101-1234',
    label: 'Svensk person',
    identityNumberKind: IDKind.SwedishPersonalID,
  },
  {
    id: '7bf435e9-39e2-4ab9-95d4-f64fb35d7833',
    name: 'Exempel Aktiebolag',
    juridicalKind: JuridicalKind.Company,
    identityNumber: '556001-1234',
    countryCode: 'SE',
    email: 'identity1@example.com',
    address: 'Address 1',
    label: 'Svenskt aktiebolag',
    identityNumberKind: IDKind.SwedishOrgNumber,
  },
];
